'use client';

import { createContext, useContext, useState } from 'react';

// Stores { en: '/services/training/training-overview', id: '/layanan/training/sekilas' }
// for the currently rendered dynamic page, sourced from navigation_path_translations.
type PathTranslations = Record<string, string> | null;

const PathTranslationCtx = createContext<{
  translations: PathTranslations;
  setTranslations: (t: PathTranslations) => void;
} | null>(null);

export function PathTranslationProvider({ children }: { children: React.ReactNode }) {
  const [translations, setTranslations] = useState<PathTranslations>(null);
  return (
    <PathTranslationCtx.Provider value={{ translations, setTranslations }}>
      {children}
    </PathTranslationCtx.Provider>
  );
}

export function usePathTranslation() {
  const ctx = useContext(PathTranslationCtx);
  if (!ctx) throw new Error('usePathTranslation must be used inside PathTranslationProvider');
  return ctx;
}
